import { Component, EventEmitter, Input, OnInit, Output, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { SignOutDialog } from '../dialogs/sign-out.dialog';
import { MatDialog } from '@angular/material/dialog';
import { UserHelper } from '@helpers/user.helper';

import { Router } from '@angular/router';
import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { ApiService } from '@services/api.service';
import { MatAccordion } from '@angular/material/expansion';
import { DataHelper } from '@helpers/data.helper';

@Component({
  selector: 'right-menu',
  templateUrl: '../sharedTemplates/right-menu.component.html',
})
export class RightMenuComponent implements AfterViewInit {
  darkThemeChecked = false;
  quickTippChecked = false;

  selectMenu: number;
  userDropdownIsOpen = false;
  isOpenLangMenu = false;
  langDatas;
  langDatasArry = [];
  selectedLang = '';
  currentRoute = '';
  @Input() isPlained = false;

  @ViewChild('accordion', { static: true }) accordion: MatAccordion;

  constructor(
    public _MatDialog: MatDialog,
    public _UserHelper: UserHelper,
    public _UiHelper: UiHelper,
    private _router: Router,
    public _LocalizationService: LocalizationService,
    public dialog: MatDialog,
    public _DataHelper: DataHelper,
    private _ApiService: ApiService
  ) {
    const theme = this._UiHelper.currentTheme;

    if (theme == 'dark') {
      this.darkThemeChecked = true;
    }

    this.quickTippChecked = this._UiHelper.getQuickTipp();

    this.currentRoute = this._UiHelper.currentRoute;
    this._UiHelper.currentRouteListener.subscribe(x => (this.currentRoute = x));
  }

  ngAfterViewInit() {
    window.scroll(0, 0);

    this.selectedLang = this._LocalizationService.LANGCODE;
    this.langDatas = this._LocalizationService.langDatas;
    Object.keys(this.langDatas).forEach(x => {
      this.langDatasArry.push(this.langDatas[x]);
    });
  }
  walletSelectChange(walletItem) {
    this._UiHelper.setLoadingDialog(true);

    this._DataHelper.selectedWallet = walletItem;

    this._ApiService.switchWallet(walletItem.CustomerId, walletItem.BranchId).then(result => {
      this._ApiService
        .getClient()
        .then(result => {
          this._UiHelper.setLoadingDialog(false);
          this._UserHelper.setUser(result);
        })
        .catch();

      this._ApiService.getTaxRate().then(result => {
        this._DataHelper.setTaxRate(result);
      });
    });
  }
  SignOutDialogOpener(x) {
    const dialogRef = this._MatDialog;
    if (x) {
      this._UiHelper.closeAllMenus();
      dialogRef
        .open(SignOutDialog, {
          width: '350px',
        })
        .afterClosed()
        .subscribe(result => {
          //////console.log('The dialog was closed' + result);
        });
    } else {
      dialogRef.closeAll();
    }
    // dialogRef.componentInstance.data = purpose;
  }

  signOutDirectly() {
    this._ApiService
      .signOut()
      .then(result => {
        this._UserHelper.userLogOut();
        this._UserHelper.customerUser = undefined;
        this._router.navigate(['/home']);
        this._UiHelper.setRefreshApp();
      })
      .catch(err => console.log('right-menu', err));
  }

  languageChangeDialogOpener(x) {
    this._UiHelper.setLanguageChangerDialog(true);
    this._UiHelper.setRightMenu();
  }

  goSlipsPage() {
    this._router.navigate(['slips']);
  }
  changeTheme() {
    this._UiHelper.darkThemeListener.emit();
  }

  closeSideBar() {
    // document.getElementById("rightSidenav").style.width = "0";
    this._UiHelper.b3000SetRightMenuState('close');
  }

  userDropdownOpen() {
    this.userDropdownIsOpen = !this.userDropdownIsOpen;
  }

  OpenAccountMobile(selectMenu) {
    this.selectMenu = selectMenu;
    this._UiHelper.b3000SetAcountMobileState('open', selectMenu);
    this._UiHelper.b3000SetRightMenuState('close');
  }

  changeQuickTipp() {
    this._UiHelper.changeQuickTipp();
  }
  selectionChange(x) {
    this._LocalizationService.changeLang(x);
    this.isOpenLangMenu = !this.isOpenLangMenu;
  }
  toggleLanguageMenu() {
    this.isOpenLangMenu = !this.isOpenLangMenu;
  }
}
